<div>
  <div>
    <button class="tourPageBtn mr-3" id="help-tour-btn" (click)="startTour()" title="Take a tour">
      <img alt="tour button" src="/assets/images/tutorialOverlayBttn.svg" />
    </button>
    <div class="header-controls">
      <h3>
        <fa-icon [icon]="enrollIcon"/>
        Enroll
      </h3>
    </div>
    <div>
      <div class="report-section-header">
        <h5 class="results-report-header"><fa-icon [icon]="studentIcon"></fa-icon> Batch Enrollment</h5>
      </div>
      <div class="boxed-content">
        @if (isUnavailable) {
          <div id="access-error" class="alert message alert-danger">
            <div class="icon">
              <fa-icon [icon]="errorIcon"></fa-icon>
            </div>
            <div>
              <div class="bold">Not Authorized</div>
              <div>This feature is not available for SSO users</div>
            </div>
          </div>
        } @else {
          <div class="diagnosticproduct-management-text-button-bar">
            <div class="diagnosticproduct-management-button-bar pull-left" >
              <input style="margin-left: 8px" type="file" id="studentCSVUpload" #studentCSVUpload class="input-file"
                     accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                     (change)="handleFileInput($event)">
              <label style="margin-left: 8px" id="upload-label" for="studentCSVUpload"><fa-icon [icon]="importIcon"></fa-icon> {{fileName}}</label>
              <button style="margin-left: 8px" type="button" id="remove-button" class="btn btn-danger" (click)="removeFile()" [disabled]="!enableRemoveFileButton()"><fa-icon [icon]="removeIcon"></fa-icon> Remove File</button>
              <button style="margin-left: 8px" type="button" id="undo-button" class="btn undo-button" (click)="undoBatchEnrollment()" [disabled]="!enableUndoButton()"><fa-icon [icon]="undoIcon"></fa-icon> Undo Last Enrollment</button>
              <button style="margin-left: 8px" type="button" id="enroll-button" class="btn btn-success" (click)="addStudents()" [disabled]="!enableEnrollButton()"><fa-icon [icon]="enrollIcon"></fa-icon> Enroll</button>
            </div>
            @if (!isCustomerService) {
              <div class="alert alert-secondary message" style="background-color: rgba(211, 211, 211, .4) ; margin-top: 10px;">
                <div class="icon">
                  <fa-icon [icon]="infoIcon"></fa-icon>
                </div>
                <div>
                  <div class="bold">Batch Student Enrollment</div>
                  <p>
                    You can upload a <a href="#" id="example-link" onclick="document.getElementById('sample-sa-batch').showModal(); return false;">properly formatted</a> comma-separated values files (commonly called a <b>csv</b> file) or an Excel spreadsheet of Student records to
                    enroll many Students at once. After you upload the file and review the Student records, press the <b>Enroll</b> button to finish enrollment
                  </p>
                </div>
              </div>
            }
            @if (showSuccessMessage()) {
              <div id="batch-success" class="alert message alert-success" style="margin-top: 10px;">
                <div class="icon">
                  <fa-icon [icon]="successIcon"></fa-icon>
                </div>
                <div>
                  <div class="bold">{{ successTitle() }}</div>
                  <div>{{ successMessage() }}</div>
                </div>
              </div>
            }
            @if (invalidBatch()) {
              <div id="batch-error" class="alert message alert-danger">
                <div class="icon">
                  <fa-icon [icon]="errorIcon"></fa-icon>
                </div>
                <div>
                  <div class="bold">Batch Enrollment Error</div>
                  <div>The following errors were encountered while trying to read your Student records:</div>
                  <ul>
                    @for (errorMessage of parseErrors(); track $index) {
                      <li>{{ errorMessage }}</li>
                    }
                  </ul>
                </div>
              </div>
            }
          </div>
          <div>
            @if (showPreview()) {
              <table class="report-table small">
                @if (isCustomerService) {
                  <thead class="diagnosticproduct-management-table-header">
                  <tr>
                    <th>Teacher</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Grade</th>
                    <th>Username</th>
                    <th>Password</th>
                    <th>Session Time</th>
                    <th>Subscription Type</th>
                    <th>Class</th>
                  </tr>
                  </thead>
                  <tbody>
                    @for (row of customerServiceBulkData(); track $index) {
                      <tr>
                        <td style="vertical-align: middle">{{row.teacherUsername}}</td>
                        <td style="vertical-align: middle">{{row.firstName}}</td>
                        <td style="vertical-align: middle">{{row.lastName}}</td>
                        <td style="vertical-align: middle">{{row.grade}}</td>
                        <td style="vertical-align: middle">{{row.username}}</td>
                        <td style="vertical-align: middle">{{row.password}}</td>
                        <td style="vertical-align: middle">{{row.sessionLength}}</td>
                        <td style="vertical-align: middle">{{row.subscriptionType}}</td>
                        <td style="vertical-align: middle">{{row.schoolClass}}</td>
                      </tr>
                    }
                  </tbody>
                } @else {
                  <thead class="diagnosticproduct-management-table-header">
                  <tr>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Grade</th>
                    <th>Primary Teacher Email</th>
                    <th>Username</th>
                    <th>Password</th>
                    <th>Session Time</th>
                  </tr>
                  </thead>
                  <tbody>
                    @for(row of schoolAdminBulkData(); track $index) {
                      <tr>
                        <td style="vertical-align: middle">{{row.firstName}}</td>
                        <td style="vertical-align: middle">{{row.lastName}}</td>
                        <td style="vertical-align: middle">{{row.grade}}</td>
                        <td style="vertical-align: middle">{{row.primaryTeacherEmail}}</td>
                        <td style="vertical-align: middle">{{row.username}}</td>
                        <td style="vertical-align: middle">{{row.password}}</td>
                        <td style="vertical-align: middle">{{row.sessionTime}}</td>
                      </tr>
                    }
                  </tbody>
                }
              </table>
            }
          </div>
        }
      </div>
      </div>
  </div>
</div>
<dialog #undoConfirmationDialog class="undo-confirmation-dialog">
  <div class="dialog-header">
    <div class="dialog-title">
      Confirm Undo Last Enrollment
    </div>
  </div>
  <div class="dialog-body">
    <p>
      This will remove the {{ latestEnrollmentStudentCount() }} students from the last batch enrollment. Are you sure you want to continue?
    </p>
    @if (latestEnrolledStudentList().length > 0) {
      <table class="report-table small undo-student-table">
        <thead class="diagnosticproduct-management-table-header">
          <tr>
            <th>Teacher Username</th>
            <th>Teacher Email</th>
            <th>Student First Name</th>
            <th>Student Last Name</th>
            <th>Grade</th>
          </tr>
        </thead>
        <tbody>
          @for (student of latestEnrolledStudentList(); track $index) {
            <tr>
              <td>{{ student.teacherUsername }}</td>
              <td>{{ student.teacherEmail }}</td>
              <td>{{ student.studentFirstName }}</td>
              <td>{{ student.studentLastName }}</td>
              <td>{{ student.grade | displayGrade }}</td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
  <div class="dialog-footer">
    <button type="button" (click)="closeUndoConfirmationDialog()">Cancel</button>
    <button type="button" class="btn-primary" (click)="confirmUndoBatchEnrollment()">Undo Enrollment</button>
  </div>
</dialog>
@if (!isCustomerService) {
  <dialog id="sample-sa-batch">
    <div class="dialog-header">
      <div class="dialog-title">
        Sample Batch Enrollment Format
      </div>
    </div>
    <div class="dialog-body">
      <div>
        The Student records file should be formatted with the first row serving as the header row, followed by one row per student. Each Student record requires
        <ul>
          <li>First Name</li>
          <li>Last Name</li>
          <li>Grade</li>
          <li>Primary Teacher Email</li>
        </ul>
        The following fields are optional, but can be specified
        <ul>
          <li>Username (will be generated if not supplied)</li>
          <li>Password (will be generated if not supplied)</li>
          <li>Session Time (defaults to 20 minutes if not supplied)</li>
        </ul>
        Please note that all Teacher accounts for the specified email address <span class="bold">must</span> exist or no Students will be enrolled. Below is a sample
        of what your Student records file should look like.
        <table class="report-table small">
          <thead class="diagnosticproduct-management-table-header">
            <tr>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Grade</th>
              <th>Primary Teacher Email</th>
              <th>Username</th>
              <th>Password</th>
              <th>Session Time</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>John</td>
              <td>Doe</td>
              <td>9</td>
              <td>teacher&amp;school.edu</td>
              <td>JohnDoe52</td>
              <td>school-year-2026</td>
              <td>60</td>
            </tr>
            <tr>
              <td>Jane</td>
              <td>Doe</td>
              <td>10</td>
              <td>teacher-2&amp;school.edu</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <div class="margin-top-10 small-instruction">
          <a class="text-decoration-none" href="/assets/templates/batch-enrollment.xlsx" download>
            <fa-icon [icon]="downloadIcon" /> Download Template
          </a>
        </div>
      </div>
    </div>
    <div class="dialog-footer">
      <button onclick="document.getElementById('sample-sa-batch').close()">Close</button>
    </div>
  </dialog>
}
